import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@psei/ng/button';

import { DateTimePickerModule } from '@psei/ng/date-time-picker';
import { IconModule } from '@psei/ng/icon';
import { SelectModule } from '@psei/ng/select';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { PseicFormFieldModule } from '../pseic-form-field/pseic-form-field.module';
import { DateFilterComponent } from './date-filter/date-filter.component';
import { TextFilterComponent } from './generic-filters/text-filter/text-filter.component';
import { PseiFiltersComponent } from './psei-filters/psei-filters.component';
import { PseicFiltersComponent } from './pseic-filters.component';

@NgModule({
    declarations: [PseicFiltersComponent, PseiFiltersComponent, TextFilterComponent, DateFilterComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    PseicFormFieldModule,
    IconModule,
    FormsModule,
    DateTimePickerModule,
    SelectModule,
    ButtonModule,
    PseiNgCustomModule,
  ],
    exports: [
        PseicFiltersComponent,
        PseiFiltersComponent,
        TextFilterComponent,
        DateFilterComponent
    ]
})
export class PseiFiltersModule {
}
